import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { excludedReasonActions } from "./excluded-reason.actions";
import { excludedReasonMutations } from "./excluded-reason.mutations";
import { excludedReasonState } from "./excluded-reason.state";

export default {
    namespaced: true,
    state: excludedReasonState,
    actions: excludedReasonActions,
    mutations: excludedReasonMutations,
} as unknown as ModuleTree<RootState>;
